import { PropsWithChildren } from 'react';
import { Stack, StackProps } from '@chakra-ui/react';

export function AdaptiveStack({ children, ...props }: PropsWithChildren & StackProps) {
  return (
    <Stack direction={{ base: 'column', lg: 'row' }} {...props}>
      {children}
    </Stack>
  );
}
